/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import SwitchButton from '../Buttons/switch';
import { targetBurnup } from '../../actions/targetActions';

class TargetBurnup extends React.Component {
  constructor() {
    super();

    this.chart = null;

    this.state = {
      loading: true,
      storyCount: false
    };

    this.generateGraph = this.generateGraph.bind(this);
  }

  componentDidMount() {
    const { graphData, targetId, targetBurnup } = this.props;

    if (graphData) {
      this.generateGraph(graphData);
    }
    if (targetId) {
      targetBurnup(targetId);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.graphData !== this.props.graphData) {
      this.generateGraph(this.props.graphData);
    }
  }

  generateGraph(data = {}) {
    this.setState({ loading: false });
    const xAxis = ['x'];
    const dates = Object.keys(data);
    const values = Object.values(data);
    const currentDate = moment().format('YYYY-MM-DD');
    const { storyCount } = this.state;
    const acceptedLabel = `${storyCount ? 'stories' : 'points'} accepted`;
    // Note: we have to do this client-side because c3 will continue a line at 0 if a value is nil instead of leaving it blank
    let plannedScopeLimit = dates.findIndex((d) => d === currentDate);
    plannedScopeLimit = plannedScopeLimit >= 0 ? plannedScopeLimit : 9999;
    let maxValueY = 0;

    const pointsAccepted = [acceptedLabel];
    const targetLine = ['target line'];
    const plannedScope = ['scope line'];
    let lastScope;
    values.forEach((value, index) => {
      xAxis.push(dates[index]);
      maxValueY =
        index === 0
          ? Math.round(value.target_burn_down * 100) / 100 + 1
          : maxValueY;
      pointsAccepted.push(value.points_accepted);
      if (index <= plannedScopeLimit) {
        lastScope = value.planned_scope;
        plannedScope.push(Math.round(value.planned_scope));
      } else {
        plannedScope.push(Math.round(lastScope));
      }
      targetLine.push(Math.round(value.target_burn_up));
    });

    this.chart = c3.generate({
      bindto: '#burnup-chart',
      data: {
        x: 'x',
        columns: [xAxis, pointsAccepted, targetLine, plannedScope],
        types: {
          [acceptedLabel]: 'bar'
        },
        colors: {
          [acceptedLabel]: '#009345',
          'scope line': 'red',
          'target line': '#CCCCCC'
        }
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            format: '%Y-%m-%d'
          }
        },
        y: {
          label: {
            position: 'outer-middle'
          },
          max: maxValueY
        },
        y2: {
          show: false
        }
      }
    });
  }

  render() {
    const { loadGraph, targetId, isLoadingData } = this.props;
    const { loading } = this.state;
    return (
      <div>
        <div>
          <SwitchButton
            label="Use Story Count instead of Points"
            handleClick={(storyCount) => {
              this.setState({ storyCount });
              loadGraph(targetId, storyCount);
            }}
          />
        </div>
        {!isLoadingData && <div id="burnup-chart" />}
        {(loading || isLoadingData) && <div id="mini-loader" />}
      </div>
    );
  }
}

TargetBurnup.propTypes = {
  graphData: PropTypes.object
};

const mapStateToProps = (state) => ({
  graphData: state.targetReducer.burnupData
});

export default connect(mapStateToProps, { targetBurnup })(TargetBurnup);
